<template>
  <div class="erSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <!-- 账户类型 -->
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!--账户名称 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
      <Col span="4">
        <!--弹性IP -->
        <Input v-model="publicIp" :placeholder="$t('alarms.common.publicIp')" />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:elasticResourceAli:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableElasticResourceAli from "../eip/TableElasticResourceAli";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import {
  CLOUD_PLATFORM_ID,
  buildPlatformOptions
} from "../../../utils/cloudPlatform.js";
var tableElasticResourceAli = TableElasticResourceAli;
export default {
  name: "ElasticResourceSearch",
  // 接受父组件的值
  props: {
    ecColumns: Array
  },
  data() {
    return {
      publicIp: "",
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.ALIYUN,
        CLOUD_PLATFORM_ID.AZURE,
        CLOUD_PLATFORM_ID.VMWARE,
        CLOUD_PLATFORM_ID.GCP
      ])
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("publicIp", this.publicIp);
      tableElasticResourceAli.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.erSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/ElasticResourceSearch.vue